import { characters } from "@/mocks/manga";

export default function Characters() {
  return (
    <section id="characters" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
            <i className="ri-user-heart-line text-sm" />
            登场人物
          </span>
          <h2 className="font-heading mt-3 text-3xl text-foreground-950 md:text-4xl">
            主要人物
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            角色介绍随漫画更新同步完善，帮助你更快进入《泡在我家的辣妹》的故事。
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {characters.map((c) => (
            <article
              key={c.id}
              className="group overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200/70 transition-shadow hover:ring-primary-200"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={c.image}
                  alt={`泡在我家的辣妹 角色 ${c.name}`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded bg-background-950/60 px-2 py-0.5 text-[11px] text-background-50 backdrop-blur-sm">
                  {c.tag}
                </span>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-xl text-foreground-950">{c.name}</h3>
                  <i className="ri-heart-3-line text-accent-500" />
                </div>
                <p className="mt-0.5 text-xs font-medium text-primary-700">{c.role}</p>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{c.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}